import { AdjustmentInventoryType } from "../validations";

export const finalData = (data: AdjustmentInventoryType) => {
    return {
        location_id: data.location_id,
        employee_id: data.employee_id,
        memo: data.memo,
        transaction_date: data.transaction_date,
        source: 2,
        trx_code: data.trx_code,
        count_id: 0,
        adjustmentdetail: data.adjusmentDetail.map((item) => {
            const stockIn = Number(item.stock_in ?? 0)

            const detail: Record<string, any> = {
                product_id: item.product_id,
                mr_unit_id: item.mr_unit_id,
                coa_coex_id: item.coa_coex_id,
                coa_inventory_id: item.coa_inventory_id,
                different_adjustment: stockIn > 0 ? item.different_adjustment * -1 : item.different_adjustment,
                different_unit: stockIn > 0 ? item.different_unit * -1 : item.different_unit,
                amount_adjustment: item.amount_adjustment,
                position: item.position,
                avg_price_use: item.avg_price_use,
            }

            if (Boolean(item.adjustment_detail_id)) {
                detail.adjustment_detail_id = item.adjustment_detail_id
            }

            return detail
        }),
        attach_file: !data?.attach_file ? [] : data.attach_file
    }
}